import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import Button from "../../../../common/ekedc-components/button/Button";
import { RecipientNotEligibleModal } from "../components/RecipientNotEligibleModal";
import styles from "./transfer-unit-recipient.module.scss";
import { ApplicationRoutes } from "../../../../routes";

export const TransferUnitRecipientPage: React.FC = () => {
	const navigate = useNavigate();
	const [meterNumber, setMeterNumber] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const [showNotEligible, setShowNotEligible] = useState(false);

	const isValid = meterNumber.trim().length >= 8;

	const handleSubmit = () => {
		if (!isValid || submitting) return;
		setSubmitting(true);
		// Placeholder: backend validate-recipient endpoint to be wired in the next step.
		// Until then, treat meter numbers ending in "0" as ineligible so the modal can be exercised.
		setTimeout(() => {
			setSubmitting(false);
			const recipient = meterNumber.trim();
			if (recipient.endsWith("0")) {
				setShowNotEligible(true);
				return;
			}
			navigate(`/${ApplicationRoutes.TRANSFER_UNIT_AMOUNT}`, { state: { recipientMeter: recipient } });
		}, 300);
	};

	return (
		<CustomerPageLayout
			title="Send Unit To"
			onBack={() => navigate(-1)}
			containerClass={styles.layoutContainer}
			contentContainerClass={styles.layoutContent}
		>
			<form
				className={styles.page}
				onSubmit={e => {
					e.preventDefault();
					handleSubmit();
				}}
			>
				{/* <header className={styles.headerRow}>
					<button type="button" className={styles.backButton} onClick={() => navigate(-1)} aria-label="Go back">
						<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
							<path
								d="M14.6667 5.5L9.16667 11L14.6667 16.5"
								stroke="var(--app-primary-text)"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
					<h1 className={styles.title}>Send Unit To</h1>
				</header> */}

				<div className={styles.scrollContent}>
					<section className={styles.card}>
						<div className={styles.cardHeader}>
							<p className={styles.cardHeaderText}>
								Enter the meter number of the person receiving the units.
							</p>
						</div>

						<div className={styles.cardBody}>
							<div className={styles.fieldGroup}>
								<label className={styles.fieldLabel} htmlFor="recipient-meter">
									Recipient Meter Number
								</label>
								<div className={styles.fieldRow}>
									<input
										id="recipient-meter"
										type="text"
										inputMode="numeric"
										pattern="[0-9]*"
										value={meterNumber}
										onChange={e => setMeterNumber(e.target.value.replace(/[^0-9]/g, ""))}
										placeholder="e.g. 76857687986"
										className={styles.fieldInput}
										maxLength={20}
									/>
								</div>
							</div>
							<p className={styles.hint}>Ensure the meter number is correct before proceeding.</p>
						</div>
					</section>
				</div>

				<footer className={styles.footer}>
					<Button
						type="submit"
						text="Validate Recipient Meter"
						disabled={!isValid}
						loading={submitting}
						loadingText="Validating…"
					/>
				</footer>
			</form>

			{showNotEligible && <RecipientNotEligibleModal onClose={() => setShowNotEligible(false)} />}
		</CustomerPageLayout>
	);
};

export default TransferUnitRecipientPage;
